import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import './UrpassTicket.css';
import { IonItem } from '@ionic/react';
import UrpassSelect from './UrpassSelect';
import { UrpassTicketType } from '../../services/types/urpassapitypes';
import { storageGetUrpassTenants } from '../../utils/storage';

type UrpassTicketProps = {
  ticket: UrpassTicketType;
  activateTicket?: (t: any) => void;
  viewTicket?: (t: any) => void;
};

export default function UrpassTicket({
  ticket,
  activateTicket,
  viewTicket,
}: UrpassTicketProps) {
  const [t] = useTranslation('global');

  const activate = () => {
    if (activateTicket) {
      activateTicket(ticket);
    }
  };

  const view = () => {
    if (viewTicket) {
      viewTicket(ticket);
    }
  };

  const subTitle = useMemo<string | undefined>(
    () =>
      ticket &&
      storageGetUrpassTenants()?.find((a) => a.id === ticket.urpassTenantId)
        ?.name,
    [ticket],
  );

  return (
    <>
      <div className="pt-1 pb-2">
        <IonItem
          lines="none"
          className="ion-no-padding ion-pt-1 pseudo-select pseudo-select-active"
        >
          <UrpassSelect
            title={ticket.name}
            icon={ticket.urpassTenantId}
            subTitle={subTitle}
            status={ticket.status}
            description={ticket.description}
            bottomAction={
              {
                inactive: activate,
                active: view,
              }[ticket.status.toLowerCase()]
            }
            bottomActionLabel={
              { inactive: t('urpass.activate'), active: t('urpass.showpass') }[
                ticket.status.toLowerCase()
              ]
            }
          />
        </IonItem>
      </div>
    </>
  );
}
